export const gtmRecommendationClickEvent = (
  blockType: string,
  category: string,
  currentProductCategoryId: number,
  destinationProductCategoryId: number,
) => ({
  event: 'recommendation_click',
  block_type: blockType,
  category,
  current_product_category_id: currentProductCategoryId,
  desination_product_category_id: destinationProductCategoryId,
});

export default gtmRecommendationClickEvent;
